const SELECTORS = {
  body: 'body',
  mobileFiltersContainer: '.boost-sd__filter-tree-vertical-sticky-overlay',
  filters: '.boost-sd__filter-option-mobile-items-selected',
  filtersMobileHeading: '.boost-sd__filter-tree-toggle-button-title',
  filtersSelected: '.boost-sd__filter-option-item-button--selected',
  activatedFiltersAttr: 'data-active-filters',
};
const observerConfig = {
  childList: true, // Observe changes in the child nodes
  subtree: true, // Observe changes in all descendants of the target
};
/**
 * @param {NodeList} mobileFiltersContainer filters node list
 * Observe activated filters and add counter to filters heading on
 * mobile devices
 */
function setFiltersObserver(mobileFiltersContainer) {
  let activatedFilters = 0;
  const counter = document.createElement('span');
  const filterHeading = document.querySelector(SELECTORS.filtersMobileHeading);
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'attributes') {
        activatedFilters = mobileFiltersContainer.querySelectorAll(SELECTORS.filtersSelected).length;
        if (activatedFilters > 0) {
          if (counter.textContent === '') {
            filterHeading.setAttribute(SELECTORS.activatedFiltersAttr, activatedFilters);
            counter.textContent = `(${activatedFilters})`;
            if (!filterHeading.querySelector('span')) filterHeading.appendChild(counter);
          } else if (counter.textContent && activatedFilters !== filterHeading.getAttribute(SELECTORS.activatedFiltersAttr)) {
            counter.textContent = `(${activatedFilters})`;
          }
        } else if (activatedFilters === 0 && filterHeading.querySelector('span')) {
          counter.textContent = '';
          filterHeading.querySelector('span').remove();
        }
      }
    });
  });
  observer.observe(mobileFiltersContainer, { ...observerConfig, attributes: true });
}
/**
 * Observe body to render mobile filters
 */
function bodyObserver() {
  const targetElement = document.querySelector(SELECTORS.body);
  const observer = new MutationObserver((mutationsList) => {
    mutationsList.forEach((mutation) => {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            const mobileFiltersContainer = node.querySelector(SELECTORS.mobileFiltersContainer);
            if (mobileFiltersContainer) {
              observer.disconnect();
              setFiltersObserver(mobileFiltersContainer);
            }
          }
        });
      }
    });
  });
  observer.observe(targetElement, observerConfig);
}
document.addEventListener('DOMContentLoaded', () => {
  if (window.innerWidth <= 767) bodyObserver();
});
